import { Col, Form, Input, Row } from "antd";
import React, { memo } from "react";

export const Title = memo(({ title, getFieldDecorator }) => {
	const validateTitleStatus = title?.length === 100 ? "warning" : "";
	return (
		<Row gutter={8}>
			<Col span={24}>
				<Form.Item
					label="Заголовок"
					validateStatus={validateTitleStatus}
					help={
						validateTitleStatus ? "Достигнут лимит в 100 символов" : undefined
					}
				>
					{getFieldDecorator("title", {
						initialValue: "",
						rules: [{ required: true, message: "Обязательное поле" }],
					})(<Input maxLength={100} />)}
				</Form.Item>
			</Col>
		</Row>
	);
});
